// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Destination,
  Value,
} from "./types";


export default __t.row({
  accountId: __t.u256().primaryKey().name("account_id"),
  delegatedKey: __t.option(__t.u256()).name("delegated_key"),
  get destination() {
    return Destination;
  },
  get uncommittedValue() {
    return Value.name("uncommitted_value");
  },
  nonce: __t.u64(),
});
